import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext(null);

export const ThemeProvider = ({ children }) => {
  const [visualTheme, setVisualTheme] = useState(() => {
    // Default for all NEW users = modern. Existing users keep their saved choice.
    return localStorage.getItem('kb-visual-theme') || 'modern';
  });

  useEffect(() => {
    localStorage.setItem('kb-visual-theme', visualTheme);
  }, [visualTheme]);

  return (
    <ThemeContext.Provider value={{ visualTheme, setVisualTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useVisualTheme = () => {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error('useVisualTheme must be used within ThemeProvider');
  return ctx;
};
